import React, { useEffect, useState } from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
 import ProductCard from "../components/ProductCard";
 import Container from "../components/Container";
import { useDispatch, useSelector } from "react-redux";
import { getAllProducts } from "../features/products/productSlice";
  import { Link, useLocation, useNavigate } from "react-router-dom";
 import ReactPaginate from "react-paginate";
import { useMediaQuery } from "react-responsive";
import { IoFilter } from "react-icons/io5";
import { MdKeyboardBackspace } from "react-icons/md";
import { useParams } from 'react-router-dom';
 import { brandByModel } from "../utils/brandsData";
  import noResults from "../images/no_result.gif";
import { RiGridFill } from "react-icons/ri";
import FilterForm from "../components/FilterForm";
import Pagination from "../components/Pagination";
  
const AllBrandsPage= () => {
  const [grid, setGrid] = useState(4);
  const productsState = useSelector(state => state?.product?.product)
  const productState = useSelector(state => state?.product?.product)
  
  const location = useLocation();
 
  const [tag, setTag] = useState(null)
 
  const [minPrice,setMinPrice]=useState(null)
  const [maxPrice, setMaxPrice] = useState(null)
  const [sort,setSort]=useState(null)
  const isDesktop = useMediaQuery({ minWidth: 768 });
  const [showFilter, setShowFilter] = useState(false); 
  const [brands, setBrands] = useState([])
   const [vehicleBrand, setVehicleBrand] = useState("");
   const [brandModel, setBrandModel] = useState("");
   const [minYear, setMinYear] = useState("");
   const [maxYear, setMaxYear] = useState("");
   const searchQuery = new URLSearchParams(location.search).get("search");

   const [selectedBudget, setSelectedBudget] = useState(null);
      const [selectedEngineSize, setSelectedEngineSize] = useState(null);
   

  useEffect(() => {
  
    let newBrands = new Set();
    for (let index = 0; index < productState.length; index++) {
      const element = productState[index];
      newBrands.add(element.brand)
      
     
    }
  
    
  
    setBrands([...newBrands])
  }, [productState]);
  

const [popularProduct, setPopularProduct] = useState([]);

const formatBrandName = (brand) => {
  if (!brand) return '';
  if (brand.toLowerCase() === 'bmw') {
    return 'BMW';
  }
  return brand
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
  
  const {type, brand: brandFromUrl } = useParams();  
 
  
  const formattedType = formatBrandName(type);

  const formattedBrand = formatBrandName(brandFromUrl);
 
useEffect(() => {
  let data = [];
  const formattedBrand = formatBrandName(brandFromUrl); 
  
  for (let index = 0; index < productsState.length; index++) {
    const element = productsState[index];
    if (element.brand === formattedBrand ) {   
      data.push(element);
    }
  }

  setPopularProduct(data);
}, [productsState, brandFromUrl]);

const dispatch = useDispatch();
const [currentPage, setCurrentPage] = useState(0);
const itemsPerPage = 14;

useEffect(() => {
  getProducts();
}, [sort, tag, formattedBrand,   minPrice, maxPrice]);

const getProducts = () => {
  dispatch(getAllProducts({ sort, tag,   brand: formattedBrand, minPrice, maxPrice }));
};


useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const engineSize = queryParams.get("engine_size"); 
  
    if (engineSize) {
      setSelectedEngineSize(engineSize); 
    }
  
   
  }, [location.search]);

  const pageCount = Math.ceil(popularProduct.length / itemsPerPage);
  const offset = currentPage * itemsPerPage;

 const handlePageChange = ({ selected: selectedPage }) => {
    setCurrentPage(selectedPage);
    window.scrollTo({ top: 0, behavior: 'smooth' });  
  };
  const currentProducts = popularProduct.slice(offset, offset + itemsPerPage);

 

 
  const navigate=useNavigate();




  const toggleFilter = () => {
    setShowFilter(prev => {
      const newShowFilter = !prev;
      document.body.style.overflow = newShowFilter ? "hidden" : "auto";
      return newShowFilter;
    });
  };

  
  const handleBackButtonClick = () => {
    setShowFilter(false);
    document.body.style.overflow = "auto"; 
  };
  

  

  const handleSearch = () => {
    document.body.style.overflow = "auto"
  }
  
  
 
    const renderFilter = () => {
      return (
        <div className="shop-by-media">
      
                  <div className="filter-back-btn-wrapper">
            <Link 
              className="filter-btn-container1"
              onClick={handleBackButtonClick}>
              <MdKeyboardBackspace className="filter-back-icon" />
              <h2>Filter</h2>
            </Link>
          </div>
        <form onSubmit={handleSubmit} className="media-filter  filter-main-wrapper">
        <div className="filter-card-el">
          <h3 className="filter-title">Brand & Model</h3>
          <div className="d-flex flex-column align-items-center gap-10">
            {/* Brand Dropdown */}
            <div className="form-floating w-100">
              <select
                className="form-select"
                value={vehicleBrand}
                onChange={handleBrandChange}
               
              >
                <option value="">Select Brand</option>
                {Object.keys(brandByModel).map((brand) => (
                  <option key={brand} value={brand}>
                    {brand}
                  </option>
                ))}
              </select>
              <label htmlFor="floatingSelect">Brand</label>
            </div>
      
      b
            <div className="form-floating w-100">
              <select
                className="form-select"
                value={brandModel}
                onChange={(e) => setBrandModel(e.target.value)}
                disabled={!vehicleBrand}
              >
                <option value="">Select Model</option>
                {brandByModel[vehicleBrand]?.map((model, index) => (
                  <option key={index} value={model}>
                    {model}
                  </option>
                ))}
              </select>
              <label htmlFor="floatingSelect">Model</label>
            </div>
          </div>
        </div>
      
        <div className="filter-card-el">
          <h3 className="filter-title">Year of Manufacture</h3>
          <div className="d-flex align-items-center gap-10">
            <div className="form-floating">
              <input
                type="text"
                className="form-control"
                placeholder="Min YOM"
                value={minYear}
                onChange={(e) => setMinYear(e.target.value)}
              />
              <label htmlFor="floatingInput">Min YOM</label>
            </div>
            <div className="form-floating">
              <input
                type="text"
                className="form-control"
                placeholder="Max YOM"
                
                value={maxYear}
                onChange={(e) => setMaxYear(e.target.value)}
              />
              <label htmlFor="floatingInput1">Max YOM</label>
            </div>
          </div>
        </div>
  
        <div className="filter-card-el">
    <h3 className="filter-title">Filter by Engine Size</h3>
    <div className="engine-size-container   ">
      <ul className="mt-3">
        {engineSizes.map((size, index) => (
          <li key={index}>
          <button 
            className={`btn ${selectedEngineSize?.trim().toLowerCase() === size.trim().toLowerCase() ? "selected-size" : " "}`}
            onClick={() => handleEngineSizeFilter(size)}
          >
            {size}
          </button>
  
  
          </li>
        ))}
      </ul>
    </div>
  </div>
      
        {/* Filter by Budget */}
        <div className="filter-card-el mb-3">
          <h3 className="filter-title">Filter by Budget</h3>
          <ul className="budget-filter-element">
            <li
              className={selectedBudget?.[0] === 0 && selectedBudget?.[1] === 500000 ? 'selected' : ''}
              onClick={() => handleBudgetFilter(0, 500000)}
            >
              0-500K
            </li>
            <li
              className={selectedBudget?.[0] === 500000 && selectedBudget?.[1] === 1000000 ? 'selected' : ''}
              onClick={() => handleBudgetFilter(500000, 1000000)}
            >
              500K-1M
            </li>
            <li
              className={selectedBudget?.[0] === 1000000 && selectedBudget?.[1] === 2000000 ? 'selected' : ''}
              onClick={() => handleBudgetFilter(1000000, 2000000)}
            >
              1M-2M
            </li>
            <li
              className={selectedBudget?.[0] === 2000000 && selectedBudget?.[1] === 3000000 ? 'selected' : ''}
              onClick={() => handleBudgetFilter(2000000, 3000000)}
            >
              2M-3M
            </li>
            <li
              className={selectedBudget?.[0] === 3000000 && selectedBudget?.[1] === 5000000 ? 'selected' : ''}
              onClick={() => handleBudgetFilter(3000000, 5000000)}
            >
              3M-5M
            </li>
            <li
              className={selectedBudget?.[0] === 5000000 && selectedBudget?.[1] === 10000000 ? 'selected' : ''}
              onClick={() => handleBudgetFilter(5000000, 10000000)}
            >
              5M-10M
            </li>
            <li
              className={selectedBudget?.[0] === 10000000 && selectedBudget?.[1] === Infinity ? 'selected' : ''}
              onClick={() => handleBudgetFilter(10000000, Infinity)}
            >
              Above 10M
            </li>
            {selectedBudget && (
              <button type="button" className="clear-btn" onClick={clearBudgetFilter}>
                Clear
              </button>
            )}
          </ul>
        </div>
      
        <button type="submit" className="btn" onClick={handleSearch}>Search</button>
      </form>
        </div>
  
               
      );
    };
  
 
    const handleSubmit = (e) => {
      e.preventDefault();
    
      const params = {
        search: searchQuery && searchQuery !== "null" ? searchQuery : undefined,
        vehicle_brand: vehicleBrand,
        brand_model: brandModel || undefined,
        year_of_manufacture__gte: minYear || undefined,
        year_of_manufacture__lte: maxYear || undefined,
        min_price: selectedBudget ? selectedBudget[0] : undefined,
        max_price: selectedBudget ? selectedBudget[1] : undefined,
        engine_size: selectedEngineSize || undefined, 
        sort: sort || undefined,
      };
    
      const filteredParams = Object.fromEntries(
        Object.entries(params).filter(([_, value]) => value !== undefined && value !== "")
      );
    
      navigate(`/search?${new URLSearchParams(filteredParams).toString()}`, { replace: true });
    };
    
    const engineSizes = Array.from(
      new Set(productState?.map(item => item.engineSize?.title).filter(Boolean))  
    );
    
     
    const handleEngineSizeFilter = (size) => {
      setSelectedEngineSize(size);
       document.body.style.overflow = "auto"
     };
  
  const handleBrandChange = (e) => {
    setVehicleBrand(e.target.value);
    setBrandModel("");  
  };

  const handleBudgetFilter = (min, max) => {
    setSelectedBudget([min, max]);
    setMinPrice(min);
    setMaxPrice(max);
};


  const clearBudgetFilter = () => {
    setSelectedBudget(null);
 
  };

  return (
    <>
    <Meta 
      title={`${formattedBrand} Cars for Sale`} 
      description={`Explore our collection of ${formattedBrand} vehicles, including popular models like ${brandByModel[formattedBrand]?.join(", ") || "various models"}. Get the best deals on reliable cars at Carman Autos.`} 
      keywords={`${formattedBrand} cars, ${formattedBrand} models, ${formattedBrand} for sale, buy ${formattedBrand}, ${formattedBrand} dealership, best ${formattedBrand} deals`} 
    />
    
     <BreadCrumb title={formattedBrand} />
      <Container class1="search-wrapper home-wrapper-2 py-5">
        <div className="row vehicle-row ">
          
          <div className=" search-container  position-relative">
        <FilterForm/>

                            <p className="totalproducts">{currentProducts.length} Vehicles</p>

            <div className="products-list   ">
                         {currentProducts.length === 0 ? (
                 <div className="no-results">
                   <img src={noResults} alt="no results gif"/>
                  </div>
               ) : (
         <>           
            {isDesktop ? (

            <>
            <div className="grid-section grid-four">
              {currentProducts.slice(0, 20).map((product, index) => (
                <ProductCard key={index} data={product} grid={grid} />
              ))}
            </div>

            </>):(
         <div className="search-list ">
         {currentProducts.map((product, index) => (
           <ProductCard key={index} data={product}  />
         ))}
       </div>
)}
</> )}

            </div>


          </div>
        </div>
            
            <Pagination
            pageCount={pageCount}
            handlePageChange={handlePageChange}
            currentPage={currentPage}
          />


        {showFilter && renderFilter()} 

      </Container>
    </>
  );
};

export default AllBrandsPage;